<style lang="scss" scoped>
.tools {
  margin-bottom: 10px;
}
</style>

<template>
  <div>
    <div class="tools">
      <Select v-model="type" clearable style="width: 100px">
        <Option value="warehouse">入库</Option>
        <Option value="delivery">出库</Option>
        <Option value="adjust">调价</Option>
        <Option value="allocation">调拨</Option>
        <Option value="return">销售退货</Option>
        <Option value="refund">进货退库</Option>
      </Select>
      <Select v-model="station" clearable style="width: 100px">
        <Option value="720001">平台</Option>
        <Option value="72000100">宜昌</Option>
        <Option value="72000101">襄阳</Option>
        <Option value="72000102">恩施</Option>
        <Option value="72000103">随州</Option>
        <Option value="72000104">利川</Option>
        <Option value="72000105">宜都</Option>
        <Option value="72000107">长阳</Option>
        <Option value="72000108">谷城</Option>
        <Option value="72000109">广水</Option>
        <Option value="72000111">当阳</Option>
        <Option value="72270001">武汉</Option>
      </Select>
      <i-input
        v-model="query"
        placeholder="请输入..."
        style="width: 200px"
      ></i-input>
      <i-button @click="load">查询</i-button>
      <i-button @click="refund">退</i-button>
      <i-button
        @click="print"
        v-show="
          type == 'allocation' ||
          type == 'warehouse' ||
          type == 'refund' ||
          type == 'return'
        "
        >打印</i-button
      >
    </div>
    <i-table
      highlight-row
      :columns="columns"
      :data="source"
      @on-selection-change="select"
    ></i-table>
    <page
      :total.sync="page.total"
      @on-change="pageChange"
      :style="{ 'margin-top': '10px', 'margin-left': '100px' }"
      :current.sync="page.current"
    ></page>
    <refund ref="refund" @finish="load"></refund>
    <return ref="return" @finish="load"></return>
  </div>
</template>

<script>
import axios from 'axios';
import Refund from './refund';
import Return from './return';

export default {
  components: {
    Refund,
    Return,
  },
  data() {
    return {
      station: '',
      type: '',
      query: '',
      page: {
        total: 0,
        current: 1,
        pagesize: 10,
      },
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
        },
        {
          title: '单号',
          key: 'no',
        },
        {
          title: '仓库',
          key: 'station',
        },
        {
          title: '编码',
          key: 'categoryId',
        },
        {
          title: '名称',
          key: 'name',
        },
        {
          //   title: '销售价',
          //   key: 'price'
          // }, {
          title: '数量',
          key: 'count',
        },
        {
          title: '成本',
          key: 'cost',
        },
        {
          title: '总成本',
          key: 'totalAmount',
        },
        {
          title: '状态',
          key: 'state',
        },
        {
          title: '备注',
          render: (h, { row }) => {
            let { subscriber, distributor } = row;
            if (subscriber || distributor) {
              let info = `${subscriber || ''} ${distributor || ''}`;
              return <span>{info}</span>;
            }
          },
        },
        {
          title: '时间',
          key: 'createdAt',
        },
      ],
      source: [],
      currentRow: null,
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    pageChange() {
      this.load();
    },
    load() {
      let { current, pagesize } = this.page;

      this.$http
        .post('order/find', {
          station: this.station,
          type: this.type,
          name: this.query,
          offset: (current - 1) * pagesize,
          limit: pagesize,
        })
        .then(({ data }) => {
          if (data.msg === 'ok') {
            this.source = data.rows.map((r) => {
              let state = r.state;
              switch (state) {
                case 1:
                  r.state = '已通过';
                  break;
                case 2:
                  r.state = '已撤销';
                  break;
                default:
                  r.state = '';
              }

              if (r.return) r.state += `(已退${r.return})`;

              return r;
            });
            this.page.total = data.count;
          }
        });
    },
    select(currentRow) {
      this.currentRow = currentRow;
    },
    refund() {
      let currentRow = this.currentRow && this.currentRow[0];
      if (currentRow) {
        if (currentRow.type === 'warehouse') {
          this.$refs.refund.show(currentRow);
        } else if (currentRow.type === 'delivery') {
          this.$refs.return.show(currentRow);
        }
      }
    },
    print() {
      let rows = this.currentRow;
      if (rows && rows.length > 0) {
        let nos = rows.map((r) => r.no);

        let id = nos.join();
        console.log(id);

        this.$http
          .get('warehouse/receipt?type=' + this.type + '&id=' + id)
          .then(({ data }) => {
            return axios.post('http://127.0.0.1:8080', data);
          });
      }
    },
  },
};
</script>
